// extracted by mini-css-extract-plugin
export default {"Editor":"EditorPage_Editor__lmOF4"};